import { Container, Text, Spinner } from './styles';

export default function Button({
  text,
  color,
  disabled = false,
  loading,
  onPress,
}) {
  return (
    <Container disabled={disabled} color={color} onClick={onPress}>
      {loading ? <Spinner /> : <Text>{text}</Text>}
    </Container>
  );
}
